import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core'
import { provideRouter, withComponentInputBinding } from '@angular/router'

import { routes } from './app.routes'
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http'
import { headersInterceptor, API_BASE_URL } from 'superlikers-microsites-api'
import { CUSTOM_CONTROLS, SETTINGS, SPANISH_ERROR_MESSAGES, VALIDATION_ERROR_MESSAGES } from 'superlikers-dynamic-forms'
import { environment } from '../environments/environment'
import { formsSettings } from '@shared/utils/forms-settings'

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withFetch(), withInterceptors([headersInterceptor])),
    {
      provide: API_BASE_URL,
      useValue: environment.baseUrl
    },
    {
      provide: VALIDATION_ERROR_MESSAGES,
      useFactory: () => SPANISH_ERROR_MESSAGES
    },
    {
      provide: SETTINGS,
      useValue: formsSettings
    },
    {
      provide: CUSTOM_CONTROLS,
      useValue: {
        textarea: () => import('@shared/components/textarea-field/textarea-field').then(m => m.TextareaField)
      }
    }
  ]
}
